/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_settings_error_failed_unlink_login_method = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Failed to unlink login method`)
};

const zh_hans1_settings_error_failed_unlink_login_method = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`无法解绑登录方式`)
};

const zh_hant1_settings_error_failed_unlink_login_method = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`無法解除綁定登入方式`)
};

const fr_settings_error_failed_unlink_login_method = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Échec de la dissociation de la méthode de connexion`)
};

const de_settings_error_failed_unlink_login_method = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Login-Methode konnte nicht getrennt werden`)
};

const ja_settings_error_failed_unlink_login_method = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ログイン方法の連携解除に失敗しました`)
};

const ko_settings_error_failed_unlink_login_method = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`로그인 방법 연결을 해제하지 못했습니다`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "zh-Hans" | "zh-Hant" | "fr" | "de" | "ja" | "ko" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const settings_error_failed_unlink_login_method = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.settings_error_failed_unlink_login_method(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("settings_error_failed_unlink_login_method", locale)
	if (locale === "en") return en_settings_error_failed_unlink_login_method(inputs)
	if (locale === "zh-Hans") return zh_hans1_settings_error_failed_unlink_login_method(inputs)
	if (locale === "zh-Hant") return zh_hant1_settings_error_failed_unlink_login_method(inputs)
	if (locale === "fr") return fr_settings_error_failed_unlink_login_method(inputs)
	if (locale === "de") return de_settings_error_failed_unlink_login_method(inputs)
	if (locale === "ja") return ja_settings_error_failed_unlink_login_method(inputs)
	return ko_settings_error_failed_unlink_login_method(inputs)
};